import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import GameSetup from './pages/GameSetup';
import GamePlay from './pages/GamePlay';
import Vote from './pages/Vote';
import Scoreboard from './pages/Scoreboard';
import Admin from './pages/Admin';
import './App.css';

function App() {
  const basename = process.env.PUBLIC_URL || '';
  
  return (
    <BrowserRouter basename={basename}>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/setup" element={<GameSetup />} />
          <Route path="/game/:gameId" element={<GamePlay />} />
          <Route path="/game/:gameId/vote" element={<Vote />} />
          <Route path="/game/:gameId/scoreboard" element={<Scoreboard />} />
          <Route path="/game/:gameId/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
